import { FC } from "react";
import { QueueListIcon } from "@heroicons/react/24/outline";

const ACTIVITY_TYPE_CONFIG = {
  icon: QueueListIcon,
  title: "Un-DNC",
};

import {
  AccountHistoryCard,
  AccountHistoryCardBasePropsI,
} from "shared/ui/activity-log/cards-v2/base";
import { HistoryCardActivityType } from "shared/ui/activity-log/cards-v2/base/activity-type";
import { HistoryCardCallerInfo } from "shared/ui/activity-log/cards-v2/base/caller-info";
import { HistoryCardCallNotes } from "shared/ui/activity-log/cards-v2/base/notes";
import { HistoryCardContactInfo } from "shared/ui/activity-log/cards-v2/base/contact-info";
import { HistoryCardAEInfo } from "shared/ui/activity-log/cards-v2/base/ae-info";

const HistoryCardUnDNCV2: FC<AccountHistoryCardBasePropsI> = ({
  activity,
  isGlenXCampaign,
}) => (
  <AccountHistoryCard createdAt={activity.created_at}>
    <div className="flex flex-col gap-4">
      <HistoryCardActivityType config={ACTIVITY_TYPE_CONFIG} />

      {activity.contact && (
        <HistoryCardContactInfo contact={activity.contact} />
      )}

      {activity.is_customer ? (
        <HistoryCardAEInfo
          aeName={activity.ae_name || "N/A"}
          isGlenXCampaign={isGlenXCampaign}
        />
      ) : (
        <HistoryCardCallerInfo callerName={activity.caller_name || "N/A"} />
      )}
    </div>

    <div className="flex flex-col gap-4">
      <HistoryCardCallNotes
        isCustomerNotes={activity.is_customer}
        isGlenXCampaign={isGlenXCampaign}
        notes={activity.notes}
      />
    </div>
  </AccountHistoryCard>
);

export default HistoryCardUnDNCV2;
